export default function Drawer({
  id,
  open,
  onClose,
  title,
  children,
}: {
  id: string;
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div
      className={[
        'fixed inset-0 z-50 lg:hidden',
        open ? '' : 'pointer-events-none',
      ].join(' ')}
      aria-hidden={!open}
    >
      {/* Backdrop */}
      <div
        className={[
          'absolute inset-0 bg-black/30 transition-opacity',
          open ? 'opacity-100' : 'opacity-0',
        ].join(' ')}
        onClick={onClose}
      />

      {/* Panel */}
      <aside
        id={id}
        className={[
          'absolute left-0 top-0 h-full w-72 bg-white shadow-xl transition-transform',
          open ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div className="text-sm font-semibold uppercase tracking-wide text-slate-500">
            {title}
          </div>
          <button className="btn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="p-3">{children}</div>
      </aside>
    </div>
  );
};
